export const safetyGuardDealerBindOption = {
  align: 'center',
  menuAlign: 'center',
  headerAlign: 'center',
  border: true,
  expand: false,
  stripe: false,
  index: false,
  selection: false,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  menuWidth: 160,
  labelWidth: 150,
  defaultSort: {
    prop: 'createTime',
    order: 'descending'
  },
  column: [
    {
      label: '绑定记录ID',
      prop: 'id',
      type: 'input',
      hide: true,
      addDisplay: false,
      editDisplay: false
    },
    {
      label: '代理商表ID',
      prop: 'safetyAgentId',
      type: 'input',
      hide: true,
      addDisplay: false,
      editDisplay: false
    },
    {
      label: '商户ID',
      prop: 'shopId',
      type: 'input',
      addDisplay: false,
      editDisplay: false
    },
    {
      label: '商户名称',
      prop: 'shopName',
      placeholder: '请输入商户名称',
      search: true,
      type: 'input'
    },
    {
      label: '商户手机号',
      prop: 'shopMobile',
      type: 'input',
      addDisplay: false,
      editDisplay: false
    },
    {
      label: '创建人',
      prop: 'createBy',
      type: 'input',
      addDisplay: false,
      editDisplay: false
    },
    {
      label: '创建时间',
      prop: 'createTime',
      type: 'datetime',
      sortable: true,
      format: 'yyyy-MM-dd HH:mm:ss',
      addDisplay: false,
      editDisplay: false
    },
    {
      label: '删除标识',
      prop: 'deleteFlag',
      type: 'input',
      hide: true,
      addDisplay: false,
      editDisplay: false
    }
  ]
};